import { render, staticRenderFns } from "./CounselWrite.vue?vue&type=template&id=f02aa872&scoped=true"
import script from "./CounselWrite.vue?vue&type=script&lang=js"
export * from "./CounselWrite.vue?vue&type=script&lang=js"
import style0 from "./CounselWrite.vue?vue&type=style&index=0&id=f02aa872&prod&lang=scss&scoped=true"
import style1 from "./CounselWrite.vue?vue&type=style&index=1&id=f02aa872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02aa872",
  null
  
)

export default component.exports